import { ValidationSummary } from 'devextreme-react/validation-summary';
import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	ExitButton,
	PrintButton,
	ScheduleDatePanel,
	SetToPendingButton,
	SubmitWOCButton,
	WOCFiles,
	WorkOrderAddNoteButton,
	WorkOrderFilesButton,
	WorkOrderInformationCards,
	WorkOrderNotesPanel,
	WorkOrderPage,
	WorkOrderProgress
} from '../../../features/cfi/work-order';
import '../../../css/order.scss';
import { FileTypes } from '../../../types/enums';

export default function WorkOrderUploadWOCPage() {

	return (
		<WorkOrderPage>

			<WorkOrderInformationCards />

			<WorkOrderProgress />

			<ValidationSummary />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<SubmitWOCButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PrintButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<WorkOrderFilesButton defaultFileType={FileTypes.WOC} />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<SetToPendingButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<WorkOrderAddNoteButton />
				</ToolbarItem>
			</Toolbar>

			<Box>
				<Item ratio={1}>
					<ScheduleDatePanel />
				</Item>
				<Item ratio={1}>
					<WorkOrderNotesPanel height={200} />
				</Item>
			</Box>

			<WOCFiles />

		</WorkOrderPage>
	)
}
